export default __webpack_public_path__ + "dd012cb958a95fc77ced4ecbb7c87040.woff";